// kr page
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware} from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import okrDetailsReducer from './reducers/goals/okrDetails.reducer';
import { okrDetailConstants } from './constants/okr/okrDetails.constants';
import { commentsConstants } from './constants/comments.constants';
import CommentsReducers from './reducers/comments.reducers';
import PersonKrApp from './components/personKrApp.component';

const initPersonKrComp = function (data) {
	showLoaderWidget($("#content"));
	const rootReducer = combineReducers({
		CommentsReducers,
		okrDetailsReducer
	});
    const personKrListStore = createStore(rootReducer,applyMiddleware(thunkMiddleware));
	personKrListStore.dispatch({type: okrDetailConstants.UPDATE_PERSON_SEARCH_RESULT,data});
	personKrListStore.dispatch({type: commentsConstants.SET_USER_DATA,data});
	ReactDOM.render(
		<Provider store={personKrListStore}>
			<PersonKrApp />
		</Provider>,
		document.getElementById('mywobo-personKrlist-wrapper'),
	);
};

window.initPersonKrComp = initPersonKrComp;
